export default function ({ route, store }) {
  if (route.name === 'index') {
    store.commit('SET_SHOW_INTRO', true)
  } else {
    store.commit('SET_SHOW_INTRO', false)
  }
}


// WEBPACK FOOTER //
// ./middleware/showIntro.js